var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.82,
    height: 14.039,
    viewBox: "0 0 14.82 14.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -30.591)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 30.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.157,44.63H1.107l.743-.8a2.79,2.79,0,0,0,.718-1.6A6,6,0,0,1,.349,39.411,5.92,5.92,0,0,1,.2,35.871a6.939,6.939,0,0,1,2.469-3.708,7.676,7.676,0,0,1,4.765-1.572,7.647,7.647,0,0,1,5.508,2.02,6.286,6.286,0,0,1,1.877,4.521,6.411,6.411,0,0,1-.472,2.424,6.245,6.245,0,0,1-1.409,2.11,7.631,7.631,0,0,1-5.5,2.028,9.35,9.35,0,0,1-2.491-.341A3.764,3.764,0,0,1,2.157,44.63Z",
    transform: "translate(0 -30.591)",
    fill: "#818c9f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.ea06bc2962526a613f5f6584b4299c9e.svg";
export { ForwardRef as ReactComponent };